module.exports = __webpack_public_path__ + "img/FLTST.a5a4760c.svg";